import React from "react";

import {
    toSelectableCropDropdownOptions,
    useCropList,
    useCompanyCropScope,
} from "~/utils/crops/use-crop-list";

import AddEditPanelContainer from "../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, service, dropdowns, model } from "../data";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    service,
    dropdowns,
});

const AddEditContainer = (props) => {
    const { crops } = useCropList({ scope: useCompanyCropScope() });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{ [model.PROPS_CROP_LIST]: toSelectableCropDropdownOptions(crops) }}
        />
    );
};

export default AddEditContainer;
